module.exports = __webpack_public_path__ + "img/XGXZ_Android.b3b3bb7f.png";